import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { useMeasure } from 'react-use';
import { useEffect } from 'react';
import { useMemo } from 'react';

const ScaleBox = ((props) => {
  const {
    className = '',
    children,
  } = props;

  const [$refContainer, { width: widthContainer }] = useMeasure();
  const [$refChild, { width: widthChild, height: heightChild }] = useMeasure();

  const scale = useMemo(() => {
    if(!widthContainer || !widthChild){
      return 1;
    }

    return widthContainer / widthChild;
  }, [widthContainer, widthChild]);

  return (
    <div 
      className={`w-full overflow-hidden ${className}`}
      style={{
        height: heightChild * scale,
      }}
      ref={$refContainer}
      >
      <div className=""
        style={{
          transform: `scale(${scale}, ${scale})`,
          transformOrigin: '0 0',
        }}
        >
        <div 
          className="w-max"
          ref={$refChild}>
          {children}
        </div>
      </div>
    </div>
  )
});
export default ScaleBox;